import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box, Button, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import AttachFile from "../../components/Comman/AttachFile";
import { LabelCompo } from "../../components/Comman/Label";
import endpoint from "../../config/endpoints";
import {
    errorAtValidationMsg,
    noInternetMsg,
    serverMsg,
    validatedSuccessfullyMsg,
} from "../../config/messageconstant";
import { apiPostForImage } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const OutletTargetImportPopUp = ({
    handleCloses,
    open,
    showNotification,
    showLoador,
    dataMethod,
}) => {

    const [fileName, setFileName] = React.useState("");

    const handleClose = () => {
        handleCloses();
    };

    const changeH = (fileName, name, index) => {
        setFileName(fileName);
    };

    const onClickViewPreview = (e, row) => {
        e.stopPropagation();
        const url = URL.createObjectURL(row);
        window.open(url);
    };

    const onClearHandler = () => {
        setFileName("");
    };

    const validatedOutletBeatMethod = (dataObj) => {
        dataMethod(dataObj);
    };

    const onValidate = async () => {
        if (navigator.onLine) {
            const formData = new FormData();
            formData.append("outletTargetExcel", fileName);

            showLoador({ loador: true });
            await apiPostForImage({
                url: endpoint.importData + "/validate-outlet-target-excel",
                postBody: formData,
            }).then(({ data, success }) => {
                if (success) {
                    if (data && data.data) {
                        if (data.error) {
                            showNotification({ msg: data.data.message, severity: "error" });
                            validatedOutletBeatMethod(data.data);
                            handleClose();
                        } else {
                            const hasErrorRow = data.data.some((item) => item.flag == 1);
                            if (hasErrorRow) {
                                showNotification({
                                    msg: errorAtValidationMsg,
                                    severity: "error",
                                });
                            } else {
                                showNotification({ msg: validatedSuccessfullyMsg });
                            }
                            validatedOutletBeatMethod(data.data);
                            handleClose();
                        }
                    }
                } else {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });
            showLoador({ loador: false });

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    return (
        <>
            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        width: "70%",
                        borderRadius: "12px",
                    },
                }}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    Import
                </BootstrapDialogTitle>
                <DialogContent dividers sx={{ backgroundColor: " #f7f8fa" }}>
                    <Grid
                        container
                        xs={12}
                        sm={12}
                        md={12}
                        spacing={0.5}
                        sx={{
                            alignItems: "flex-start",
                            flexWrap: { xs: "wrap", md: "nowrap" },
                        }}
                    >
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                    padding: "10px 5px 10px 5px",
                                    justifyContent: "flex-start",
                                }}
                            >
                                {/* First Row - Label and File Input */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                    }}
                                >
                                    {fileName === "" && (
                                        <>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <LabelCompo
                                                    className="text-black"
                                                    style={{
                                                        fontSize: 18,
                                                        fontWeight: 500,
                                                        color: "#d32f2f",
                                                    }}
                                                    label={"*"}
                                                />
                                                <LabelCompo
                                                    className="text-black"
                                                    style={{
                                                        fontSize: 17,
                                                        fontWeight: 450,
                                                        color: "#424242",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                    label={"Select Excel File :"}
                                                />
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexGrow: 1,
                                                }}
                                            >
                                                <AttachFile
                                                    name={"file"}
                                                    fileName={changeH}
                                                    sx={{ flexGrow: 1, minWidth: 0 }}
                                                />
                                            </Box>
                                        </>
                                    )}
                                </Box>

                                {/* Second Row - File Name and Preview Icon (only when file is selected) */}
                                {fileName !== "" && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            onClick={(e) => onClickViewPreview(e, fileName)}
                                            sx={{
                                                fontSize: 17,
                                                fontWeight: 400,
                                                wordWrap: "break-word",
                                                overflowWrap: "break-word",
                                                whiteSpace: "normal",
                                                maxWidth: "800px",
                                                flex: "1 1 auto",
                                                color: " #004969",
                                                cursor: "pointer",
                                                textDecoration: "none", // No underline by default
                                                "&:hover": {
                                                    textDecoration: "underline", // Show underline on hover
                                                },
                                            }}
                                        >
                                            {fileName.name}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogContent dividers>
                    <Grid
                        container
                        xs={12}
                        sm={12}
                        md={12}
                        spacing={1}
                        sx={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        {fileName === "" && (
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                sx={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: "14px",
                                        color: "#555",
                                        textAlign: "right",
                                    }}
                                >
                                    Select the Excel File to import data.
                                </Typography>
                            </Grid>
                        )}

                        {fileName !== "" && (
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        startIcon={<ClearIcon />}
                                        sx={{
                                            borderRadius: 2,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            minWidth: "120px",
                                            height: "35px",
                                            borderColor: "#ffcccb",
                                            color: "#d32f2f",
                                            backgroundColor: "#fff1f0",
                                            boxShadow: "0 3px 6px rgba(248, 248, 248, 0.1)",
                                            transition: "all 0.3s ease",
                                            "&:hover": {
                                                backgroundColor: "#ffe6e5",
                                                borderColor: "#d32f2f",
                                                color: "#b71c1c",
                                                transform: "translateY(-2px)",
                                                boxShadow: "0 6px 12px rgba(248, 248, 248, 0.2)",
                                            },
                                        }}
                                        onClick={onClearHandler}
                                    >
                                        Clear
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="medium"
                                        startIcon={<CloudUploadIcon sx={{ color: "#fff" }} />}
                                        sx={{
                                            color: "#fff",
                                            borderRadius: 2,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            transition: "all 0.2s",
                                            minWidth: "150px",
                                            height: "35px",
                                            "&:hover": {
                                                backgroundColor: "#1976d2",
                                                transform: "translateY(-2px)",
                                            },
                                        }}
                                        onClick={onValidate}
                                    >
                                        Validate
                                    </Button>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
            </BootstrapDialog>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
    showNotification,
    showLoador,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OutletTargetImportPopUp);
